// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"773":"2b1ea0a0aadc6efa","808":"a92885f1d40a7576"}[chunkId] + ".js";
};